import { Card, CardContent, Box } from '@mui/material';

/**
 * Soft card wrapping filter controls for list pages.
 */
export default function FilterBar({ children, sx, contentSx }) {
  return (
    <Card sx={{ mb: 2, ...sx }}>
      <CardContent
        sx={{
          py: 1.75,
          '&:last-child': { pb: 1.75 },
          ...contentSx
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            flexWrap: 'wrap'
          }}
        >
          {children}
        </Box>
      </CardContent>
    </Card>
  );
}
